import base from "./base";
import request from "./request";

class Api {
  /* 公共模块URL */
  public static commonUrl = {
    websocket: () =>
      `${base.common}/ws/webSocket`
        .replace("https", "wss")
        .replace("http", "ws"),
    wxWebsocket: (urlParam = "") =>
      (`${base.common}/ws/wxWebSocket?scene=` + urlParam)
        .replace("https", "wss")
        .replace("http", "ws"),
    enum: (urlParam = "") => `${base.common}/api/enum/` + urlParam,
    dict: (urlParam = "") => `${base.common}/api/dict/children/` + urlParam,
    register: () => `${base.common}/api/register`,
    reset: () => `${base.common}/api/reset`,
    wxLoginQrcode: (urlParam = "") =>
      `${base.common}/api/anon/wxLoginQrcode/` + urlParam,
    wxBindQrcode: (urlParam = "") =>
      `${base.common}/api/anon/wxBindQrcode/` + urlParam,
    permMenu: () => `${base.common}/api/perm/menu`,
    fileAdd: () => `${base.common}/api/file/add`,
    fileUpload: () => `${base.common}/api/file/upload`,
    fileReplace: () => `${base.common}/api/file/replace`,
    filePreview: (urlParam = "") =>
      `${base.common}/api/file/preview/` + urlParam,
    anonFilePreview: (fileId = "", thumb = false) =>
      `${base.cdn}/api/anon/file/preview/${fileId}${thumb ? "?thumb=true" : ""}`,
    /** 源站预览（CDN 失败时回退） */
    anonFilePreviewOrigin: (fileId = "", thumb = false) =>
      `${base.common}/api/anon/file/preview/${fileId}${thumb ? "?thumb=true" : ""}`,
    /**
     * 微信虚拟支付批量添加道具专用图（走源站，保证 CORS / 尺寸 / 体积）
     * 200x200 JPG，≤200KB，Access-Control-Allow-Origin: https://mp.weixin.qq.com
     */
    anonWxVirtualGoodsImage: (fileId = "") =>
      `${base.common}/api/anon/file/wxVirtualGoods/${fileId}`,
    anonFileDownload: (fileId = "") =>
      `${base.cdn}/api/anon/file/download/${fileId}`,
    anonFileDownloadOrigin: (fileId = "") =>
      `${base.common}/api/anon/file/download/${fileId}`,
    license: () => `${base.common}/api/license`,
    userSetAvatar: () => `${base.common}/api/user/setAvatar`,
    userEdit: () => `${base.common}/api/user/edit`,
    userEditPassword: () => `${base.common}/api/user/editPassword`,
    wsGetWsStatus: () => `${base.common}/api/ws/getWsStatus`,
  };
  /* 公共模块 */
  public static common = {
    login: (params = {}) => request.post(`${base.common}/api/login`, params),
    smsLogin: (params = {}) =>
      request.post(`${base.common}/api/smsLogin`, params),
    sendSmsCode: (params = {}) =>
      request.post(`${base.common}/api/anon/sms/sendCode`, params),
    bindPhoneBySms: (params = {}) =>
      request.post(`${base.common}/api/wx/bindPhoneBySms`, params),
    wxLogin: (params = {}) =>
      request.post(`${base.common}/api/wxLogin`, params),
    wxBind: (params = {}) =>
      request.post(`${base.common}/api/user/wxBind`, params),
    logout: (params = {}) => request.post(`${base.common}/api/logout`, params),
    register: (params = {}) => request.post(Api.commonUrl.register(), params),
    reset: (params = {}) => request.post(Api.commonUrl.reset(), params),
    wxLoginQrcode: (urlParam = "") =>
      request.get(Api.commonUrl.wxLoginQrcode(urlParam)),
    auth: () => request.post(`${base.common}/api/auth`),
    clearAuth: () => request.post(`${base.common}/api/clearAuth`),
    lang: () => request.post(`${base.common}/api/lang`),
    enum: (urlParam = "") => request.post(Api.commonUrl.enum(urlParam)),
    dict: (urlParam = "") => request.post(Api.commonUrl.dict(urlParam)),
    permMenu: () => request.post(Api.commonUrl.permMenu()),
    fileAdd: (params = {}) => request.post(Api.commonUrl.fileAdd(), params),
    fileUpload: (params = {}) =>
      request.post(Api.commonUrl.fileUpload(), params),
    fileReplace: (params = {}) =>
      request.post(Api.commonUrl.fileReplace(), params),
    filePage: (params = {}) =>
      request.post(`${base.common}/api/file/page`, params),
    fileDetail: (id = "") =>
      request.post(`${base.common}/api/file/detail/` + id),
    fileEdit: (params = {}) =>
      request.post(`${base.common}/api/file/edit`, params),
    fileDelete: (params = {}) =>
      request.post(`${base.common}/api/file/delete`, params),
    filePreview: (urlParam = "") =>
      request.post(Api.commonUrl.filePreview(urlParam)),
    license: (params = {}) => request.get(Api.commonUrl.license(), params),
    userSetAvatar: (params = {}) =>
      request.post(Api.commonUrl.userSetAvatar(), params),
    userSetMyUserInfo: (params = {}) =>
      request.post(`${base.common}/api/user/setMyUserInfo`, params),
    userSetMyPassword: (params = {}) =>
      request.post(`${base.common}/api/user/setMyPassword`, params),
    userDetail: (id = "") =>
      request.post(`${base.common}/api/user/detail/` + id),
    userAdd: (params = {}) =>
      request.post(`${base.common}/api/user/add`, params),
    userEdit: (params = {}) => request.post(Api.commonUrl.userEdit(), params),
    userDelete: (params = {}) =>
      request.post(`${base.common}/api/user/delete`, params),
    userPage: (params = {}) =>
      request.post(`${base.common}/api/user/page`, params),
    userEditPassword: (params = {}) =>
      request.post(Api.commonUrl.userEditPassword(), params),
    wsGetWsStatus: (params = {}) =>
      request.post(Api.commonUrl.wsGetWsStatus(), params),
    anonConfig: () => request.post(`${base.common}/api/anon/config`),
    anonCategoryList: (params = {}) =>
      request.post(`${base.common}/api/anon/category/list`, params),
    anonProductList: (params = {}) =>
      request.post(`${base.common}/api/anon/product/list`, params),
    anonProductDetail: (id = "") =>
      request.post(`${base.common}/api/anon/product/detail/` + id),
    anonShopList: (params = {}) =>
      request.post(`${base.common}/api/anon/shop/list`, params),
    orgList: (params = {}) =>
      request.post(`${base.common}/api/org/list`, params),
    orgDetail: (id = "") => request.post(`${base.common}/api/org/detail/` + id),
    orgAdd: (params = {}) => request.post(`${base.common}/api/org/add`, params),
    orgEdit: (params = {}) =>
      request.post(`${base.common}/api/org/edit`, params),
    orgDelete: (params = {}) =>
      request.post(`${base.common}/api/org/delete`, params),
    orgPage: (params = {}) =>
      request.post(`${base.common}/api/org/page`, params),
    permList: (params = {}) =>
      request.post(`${base.common}/api/perm/list`, params),
    permDetail: (id = "") =>
      request.post(`${base.common}/api/perm/detail/` + id),
    permAdd: (params = {}) =>
      request.post(`${base.common}/api/perm/add`, params),
    permEdit: (params = {}) =>
      request.post(`${base.common}/api/perm/edit`, params),
    permDelete: (params = {}) =>
      request.post(`${base.common}/api/perm/delete`, params),
    permPage: (params = {}) =>
      request.post(`${base.common}/api/perm/page`, params),
    roleList: (params = {}) =>
      request.post(`${base.common}/api/role/list`, params),
    roleDetail: (id = "") =>
      request.post(`${base.common}/api/role/detail/` + id),
    roleAdd: (params = {}) =>
      request.post(`${base.common}/api/role/add`, params),
    roleEdit: (params = {}) =>
      request.post(`${base.common}/api/role/edit`, params),
    roleDelete: (params = {}) =>
      request.post(`${base.common}/api/role/delete`, params),
    rolePage: (params = {}) =>
      request.post(`${base.common}/api/role/page`, params),
    rolePerms: (id = "") => request.post(`${base.common}/api/role/perms/` + id),
    roleAddPerms: (params = {}) =>
      request.post(`${base.common}/api/role/addPerms`, params),
    dictList: (params = {}) =>
      request.post(`${base.common}/api/dict/list`, params),
    dictDetail: (id = "") =>
      request.post(`${base.common}/api/dict/detail/` + id),
    dictAdd: (params = {}) =>
      request.post(`${base.common}/api/dict/add`, params),
    dictEdit: (params = {}) =>
      request.post(`${base.common}/api/dict/edit`, params),
    dictDelete: (params = {}) =>
      request.post(`${base.common}/api/dict/delete`, params),

    configPage: (params = {}) =>
      request.post(`${base.common}/api/config/page`, params),
    configDetail: (id = "") =>
      request.post(`${base.common}/api/config/detail/` + id),
    configAdd: (params = {}) =>
      request.post(`${base.common}/api/config/add`, params),
    configEdit: (params = {}) =>
      request.post(`${base.common}/api/config/edit`, params),
    configDelete: (params = {}) =>
      request.post(`${base.common}/api/config/delete`, params),

    msgPage: (params = {}) =>
      request.post(`${base.common}/api/msg/page`, params),
    msgDetail: (id = "") => request.post(`${base.common}/api/msg/detail/` + id),
    // msgAdd: (params = {}) => request.post(`${base.common}/api/msg/add`, params),
    msgEdit: (params = {}) =>
      request.post(`${base.common}/api/msg/edit`, params),
    msgDelete: (params = {}) =>
      request.post(`${base.common}/api/msg/delete`, params),
    msgRead: (params = {}) =>
      request.post(`${base.common}/api/msg/read`, params),
    msgUnreadPage: (params = {}) =>
      request.post(`${base.common}/api/msg/unreadPage`, params),
    msgSend: (params = {}) =>
      request.post(`${base.common}/api/msg/send`, params),
  };

  /* 预约模块URL */
  public static rezUrl = {
    shopImgSet: () => `${base.common}/api/shop/imgSet`,
    shopAdImgSet: () => `${base.common}/api/shop/adImgSet`,
    roomImgSet: () => `${base.common}/api/room/imgSet`,
    roomAudioSet: () => `${base.common}/api/room/audioSet`,
    shopLogoSet: () => `${base.common}/api/shop/logoSet`,
    shopTermsSet: () => `${base.common}/api/shop/termsSet`,
    shopMeImgSet: () => `${base.common}/api/shop/meImgSet`,
  };

  /* 预约模块 */
  public static rez = {
    shopList: (params = {}) =>
      request.post(`${base.common}/api/shop/list`, params),
    shopDetail: (id = "") =>
      request.post(`${base.common}/api/shop/detail/` + id),
    shopVoDetail: (id = "") =>
      request.post(`${base.common}/api/shop/vo/detail/` + id),
    shopAdd: (params = {}) =>
      request.post(`${base.common}/api/shop/add`, params),
    shopEdit: (params = {}) =>
      request.post(`${base.common}/api/shop/edit`, params),
    shopDelete: (params = {}) =>
      request.post(`${base.common}/api/shop/delete`, params),
    shopPage: (params = {}) =>
      request.post(`${base.common}/api/shop/page`, params),
    shopImgSet: (params = {}) => request.post(Api.rezUrl.shopImgSet(), params),
    shopImgDelete: (params = {}) =>
      request.post(`${base.common}/api/shop/imgDelete`, params),
    shopImgList: (id = "") =>
      request.post(`${base.common}/api/shop/imgList/` + id),
    shopAdImgSet: (params = {}) =>
      request.post(Api.rezUrl.shopAdImgSet(), params),
    shopAdImgList: (id = "") =>
      request.post(`${base.common}/api/shop/adImgList/` + id),
    shopAdImgDelete: (params = {}) =>
      request.post(`${base.common}/api/shop/adImgDelete`, params),
    shopLogoSet: (params = {}) =>
      request.post(Api.rezUrl.shopLogoSet(), params),
    shopLogoDelete: (params = {}) =>
      request.post(`${base.common}/api/shop/logoDelete`, params),
    shopLogoList: (id = "") =>
      request.post(`${base.common}/api/shop/logoList/` + id),
    shopTermsSet: (params = {}) =>
      request.post(Api.rezUrl.shopTermsSet(), params),
    shopTermsDelete: (params = {}) =>
      request.post(`${base.common}/api/shop/termsDelete`, params),
    shopTermsList: (id = "") =>
      request.post(`${base.common}/api/shop/termsList/` + id),
    shopMeImgSet: (params = {}) =>
      request.post(Api.rezUrl.shopMeImgSet(), params),
    shopMeImgDelete: (params = {}) =>
      request.post(`${base.common}/api/shop/meImgDelete`, params),
    shopMeImgList: (id = "") =>
      request.post(`${base.common}/api/shop/meImgList/` + id),
    shopRoomSet: (params = {}) =>
      request.post(`${base.common}/api/shop/roomSet`, params),
    shopRoomList: (id = "") =>
      request.post(`${base.common}/api/shop/roomList/` + id),
    shopUserSet: (params = {}) =>
      request.post(`${base.common}/api/shop/userSet`, params),
    shopUserList: (id = "") =>
      request.post(`${base.common}/api/shop/userList/` + id),

    schedOpen: (params = {}) =>
      request.post(`${base.common}/api/shop/schedOpen`, params),
    schedClose: (id = "") =>
      request.post(`${base.common}/api/shop/schedClose/` + id),

    eightHourOpen: (id = "") =>
      request.post(`${base.common}/api/shop/eightHourOpen/` + id),
    eightHourClose: (id = "") =>
      request.post(`${base.common}/api/shop/eightHourClose/` + id),

    businessStatusOpen: (id = "") =>
      request.post(`${base.common}/api/shop/businessStatusOpen/` + id),
    businessStatusClose: (id = "") =>
      request.post(`${base.common}/api/shop/businessStatusClose/` + id),

    rezDetail: (id = "") => request.post(`${base.common}/api/rez/detail/` + id),
    rezAdd: (params = {}) => request.post(`${base.common}/api/rez/add`, params),
    rezEdit: (params = {}) =>
      request.post(`${base.common}/api/rez/edit`, params),
    rezDelete: (params = {}) =>
      request.post(`${base.common}/api/rez/delete`, params),
    rezPage: (params = {}) =>
      request.post(`${base.common}/api/rez/page`, params),
    rezDashboard: (params = {}) =>
      request.post(`${base.common}/api/rez/dashboard`, params),
    profitDashboard: (params = {}) =>
      request.post(`${base.common}/api/rez/profitDashboard`, params),
    salaryDashboard: (params = {}) =>
      request.post(`${base.common}/api/salary/dashboard`, params),
    salaryDashboardLegacy: (params = {}) =>
      request.post(`${base.common}/api/salary/dashboardLegacy`, params),
    salaryProfitDashboard: (params = {}) =>
      request.post(`${base.common}/api/salary/profitDashboard`, params),
    /** 始终走老利润汇总，对照用 */
    salaryProfitDashboardLegacy: (params = {}) =>
      request.post(`${base.common}/api/salary/profitDashboardLegacy`, params),
    /** 仪表盘优化开关实际状态 */
    salaryDashboardFlags: (params = {}) =>
      request.post(`${base.common}/api/salary/dashboardFlags`, params),
    salaryArcPage: (params = {}) =>
      request.post(`${base.common}/api/salaryArc/page`, params),
    roomList: (params = {}) =>
      request.post(`${base.common}/api/room/list`, params),
    roomDetail: (id = "") =>
      request.post(`${base.common}/api/room/detail/` + id),
    roomAdd: (params = {}) =>
      request.post(`${base.common}/api/room/add`, params),
    roomEdit: (params = {}) =>
      request.post(`${base.common}/api/room/edit`, params),
    roomDelete: (params = {}) =>
      request.post(`${base.common}/api/room/delete`, params),
    roomPage: (params = {}) =>
      request.post(`${base.common}/api/room/page`, params),
    roomImgSet: (params = {}) => request.post(Api.rezUrl.roomImgSet(), params),
    roomImgDelete: (params = {}) =>
      request.post(`${base.common}/api/room/imgDelete`, params),
    roomImgList: (id = "") =>
      request.post(`${base.common}/api/room/imgList/` + id),
    roomAudioSet: (params = {}) =>
      request.post(Api.rezUrl.roomAudioSet(), params),
    roomAudioDelete: (params = {}) =>
      request.post(`${base.common}/api/room/audioDelete`, params),
    roomAudioList: (id = "") =>
      request.post(`${base.common}/api/room/audioList/` + id),
    roomOpen: (id = "") =>
      request.post(`${base.common}/api/room/roomOpen/` + id),
    roomClose: (id = "") =>
      request.post(`${base.common}/api/room/roomClose/` + id),
    roomFinish: (id = "") =>
      request.post(`${base.common}/api/room/roomFinish/` + id),
    deviceList: (params = {}) =>
      request.post(`${base.common}/api/device/list`, params),
    deviceDetail: (id = "") =>
      request.post(`${base.common}/api/device/detail/` + id),
    deviceAdd: (params = {}) =>
      request.post(`${base.common}/api/device/add`, params),
    deviceEdit: (params = {}) =>
      request.post(`${base.common}/api/device/edit`, params),
    deviceDelete: (params = {}) =>
      request.post(`${base.common}/api/device/delete`, params),
    devicePage: (params = {}) =>
      request.post(`${base.common}/api/device/page`, params),

    memberList: (params = {}) =>
      request.post(`${base.common}/api/member/list`, params),
    memberDetail: (id = "") =>
      request.post(`${base.common}/api/member/detail/` + id),
    memberDetailByPhone: (phone = "") =>
      request.post(`${base.common}/api/member/detailByPhone/` + phone),
    memberAdd: (params = {}) =>
      request.post(`${base.common}/api/member/add`, params),
    memberEdit: (params = {}) =>
      request.post(`${base.common}/api/member/edit`, params),
    memberDelete: (params = {}) =>
      request.post(`${base.common}/api/member/delete`, params),
    memberPage: (params = {}) =>
      request.post(`${base.common}/api/member/page`, params),
    memberTransfer: (params = {}) =>
      request.post(`${base.common}/api/member/transfer`, params),

    rechargeCardList: (params = {}) =>
      request.post(`${base.common}/api/rechargeCard/list`, params),
    rechargeCardDetail: (id = "") =>
      request.post(`${base.common}/api/rechargeCard/detail/` + id),
    rechargeCardAdd: (params = {}) =>
      request.post(`${base.common}/api/rechargeCard/add`, params),
    rechargeCardEdit: (params = {}) =>
      request.post(`${base.common}/api/rechargeCard/edit`, params),
    rechargeCardDelete: (params = {}) =>
      request.post(`${base.common}/api/rechargeCard/delete`, params),
    rechargeCardPage: (params = {}) =>
      request.post(`${base.common}/api/rechargeCard/page`, params),

    rechargePage: (params = {}) =>
      request.post(`${base.common}/api/recharge/page`, params),
    rechargeChangeMoney: (params = {}) =>
      request.post(`${base.common}/api/recharge/changeMoney`, params),

    salaryDetail: (id = "") =>
      request.post(`${base.common}/api/salary/detail/` + id),
    salaryDetailByRoomId: (id = "") =>
      request.post(`${base.common}/api/salary/detailByRoomId/` + id),
    salarySave: (params = {}) =>
      request.post(`${base.common}/api/salary/save`, params),
    salaryArcSave: (params = {}) =>
      request.post(`${base.common}/api/salaryArc/save`, params),
    salaryArcPre: (params = {}) =>
      request.post(`${base.common}/api/salaryArc/preArc`, params),

    v2SalaryDetail: (id = "") =>
      request.post(`${base.common}/api/v2/salary/detail/` + id),
    v2SalaryDetailByRoomId: (id = "") =>
      request.post(`${base.common}/api/v2/salary/detailByRoomId/` + id),
    v2SalaryAdd: (params = {}) =>
      request.post(`${base.common}/api/v2/salary/add`, params),
    v2SalaryEdit: (params = {}) =>
      request.post(`${base.common}/api/v2/salary/edit`, params),
    v2SalaryDashboard: (params = {}) =>
      request.post(`${base.common}/api/v2/salary/dashboard`, params),
    v2SalaryProfitDashboard: (params = {}) =>
      request.post(`${base.common}/api/v2/salary/profitDashboard`, params),

    rewardDetail: (id = "") =>
      request.post(`${base.common}/api/reward/detail/` + id),
    rewardAdd: (params = {}) =>
      request.post(`${base.common}/api/reward/add`, params),
    rewardEdit: (params = {}) =>
      request.post(`${base.common}/api/reward/edit`, params),
    rewardEditFull: (params = {}) =>
      request.post(`${base.common}/api/reward/editFull`, params),
    rewardDelete: (params = {}) =>
      request.post(`${base.common}/api/reward/delete`, params),
    rewardTransfer: (params = {}) =>
      request.post(`${base.common}/api/reward/transfer`, params),
    rewardTransferByPhone: (params = {}) =>
      request.post(`${base.common}/api/reward/transferByPhone`, params),
    rewardPage: (params = {}) =>
      request.post(`${base.common}/api/reward/page`, params),
    rewardRoomDashboard: (params = {}) =>
      request.post(`${base.common}/api/reward/roomDashboard`, params),
    rewardRoomBoardList: (params = {}) =>
      request.post(`${base.common}/api/reward/roomBoardList`, params),
    /** 始终走老房间看板列表，对照用 */
    rewardRoomBoardListLegacy: (params = {}) =>
      request.post(`${base.common}/api/reward/roomBoardListLegacy`, params),

    rewardReviewPage: (params = {}) =>
      request.post(`${base.common}/api/rewardReview/page`, params),
    rewardReviewDetail: (id = "") =>
      request.post(`${base.common}/api/rewardReview/detail/` + id),
    rewardReviewEdit: (params = {}) =>
      request.post(`${base.common}/api/rewardReview/edit`, params),
    rewardReviewDelete: (params = {}) =>
      request.post(`${base.common}/api/rewardReview/delete`, params),

    rewardReviewAdd: (params = {}) =>
      request.post(`${base.common}/api/rewardReview/add`, params),
    rewardReviewAdminAdd: (params = {}) =>
      request.post(`${base.common}/api/rewardReview/adminAdd`, params),
    rewardReviewAdminClear: (rewardId = "") =>
      request.post(`${base.common}/api/rewardReview/adminClear/` + rewardId),
    rewardReviewByReward: (rewardId: string | number) =>
      request.post(`${base.common}/api/rewardReview/byReward/${rewardId}`),

    employeeList: (params = {}) =>
      request.post(`${base.common}/api/employee/list`, params),
    employeeDetail: (id = "") =>
      request.post(`${base.common}/api/employee/detail/` + id),
    employeeDetailByPhone: (phone = "") =>
      request.post(`${base.common}/api/employee/detailByPhone/` + phone),
    employeeAdd: (params = {}) =>
      request.post(`${base.common}/api/employee/add`, params),
    employeeEdit: (params = {}) =>
      request.post(`${base.common}/api/employee/edit`, params),
    employeeDelete: (params = {}) =>
      request.post(`${base.common}/api/employee/delete`, params),
    employeePage: (params = {}) =>
      request.post(`${base.common}/api/employee/page`, params),
  };

  public static catUrl = {
    productCoverSet: () => `${base.common}/api/product/coverSet`,
    productVideoSet: () => `${base.common}/api/product/videoSet`,
  };
  public static cat = {
    categoryList: (params = {}) =>
      request.post(`${base.common}/api/category/list`, params),
    categoryDetail: (id = "") =>
      request.post(`${base.common}/api/category/detail/` + id),
    categoryAdd: (params = {}) =>
      request.post(`${base.common}/api/category/add`, params),
    categoryEdit: (params = {}) =>
      request.post(`${base.common}/api/category/edit`, params),
    categoryDelete: (params = {}) =>
      request.post(`${base.common}/api/category/delete`, params),
    categoryPage: (params = {}) =>
      request.post(`${base.common}/api/category/page`, params),

    productList: (params = {}) =>
      request.post(`${base.common}/api/product/list`, params),
    productDetail: (id = "") =>
      request.post(`${base.common}/api/product/detail/` + id),
    productAdd: (params = {}) =>
      request.post(`${base.common}/api/product/add`, params),
    productEdit: (params = {}) =>
      request.post(`${base.common}/api/product/edit`, params),
    productDelete: (params = {}) =>
      request.post(`${base.common}/api/product/delete`, params),
    productPage: (params = {}) =>
      request.post(`${base.common}/api/product/page`, params),
    productInitVirtualProductId: (params = {}) =>
      request.post(`${base.common}/api/product/initVirtualProductId`, params),
    productCoverSet: (params = {}) =>
      request.post(Api.catUrl.productCoverSet(), params),
    productCoverDelete: (params = {}) =>
      request.post(`${base.common}/api/product/coverDelete`, params),
    productCoverList: (id = "") =>
      request.post(`${base.common}/api/product/coverList/` + id),
    productVideoSet: (params = {}) =>
      request.post(Api.catUrl.productVideoSet(), params),
    productVideoDelete: (params = {}) =>
      request.post(`${base.common}/api/product/videoDelete`, params),
    productVideoList: (id = "") =>
      request.post(`${base.common}/api/product/videoList/` + id),

    productSetList: (params = {}) =>
      request.post(`${base.common}/api/productSet/list`, params),
    productSetDetail: (id = "") =>
      request.post(`${base.common}/api/productSet/detail/` + id),
    productSetAdd: (params = {}) =>
      request.post(`${base.common}/api/productSet/add`, params),
    productSetEdit: (params = {}) =>
      request.post(`${base.common}/api/productSet/edit`, params),
    productSetDelete: (params = {}) =>
      request.post(`${base.common}/api/productSet/delete`, params),
    productSetPage: (params = {}) =>
      request.post(`${base.common}/api/productSet/page`, params),
    productSetProductList: (id = "") =>
      request.post(`${base.common}/api/productSet/productList/` + id),
    productSetProductSet: (params = {}) =>
      request.post(`${base.common}/api/productSet/productSet`, params),

    productSetPhoneList: (params = {}) =>
      request.post(`${base.common}/api/productSetPhone/list`, params),
    productSetPhoneDetail: (id = "") =>
      request.post(`${base.common}/api/productSetPhone/detail/` + id),
    productSetPhoneAdd: (params = {}) =>
      request.post(`${base.common}/api/productSetPhone/add`, params),
    productSetPhoneEdit: (params = {}) =>
      request.post(`${base.common}/api/productSetPhone/edit`, params),
    productSetPhoneDelete: (params = {}) =>
      request.post(`${base.common}/api/productSetPhone/delete`, params),
    productSetPhonePage: (params = {}) =>
      request.post(`${base.common}/api/productSetPhone/page`, params),
    productSetPhoneDetailByPhoneAndProductSetId: (params = {}) =>
      request.post(
        `${base.common}/api/productSetPhone/detailByPhoneAndProductSetId`,
        params
      ),
  };

  public static pointUrl = {
    couponCoverSet: () => `${base.common}/api/coupon/coverSet`,
    couponVideoSet: () => `${base.common}/api/coupon/videoSet`,
  };
  public static point = {
    couponList: (params = {}) =>
      request.post(`${base.common}/api/coupon/list`, params),
    couponDetail: (id = "") =>
      request.post(`${base.common}/api/coupon/detail/` + id),
    couponAdd: (params = {}) =>
      request.post(`${base.common}/api/coupon/add`, params),
    couponEdit: (params = {}) =>
      request.post(`${base.common}/api/coupon/edit`, params),
    couponDelete: (params = {}) =>
      request.post(`${base.common}/api/coupon/delete`, params),
    couponPage: (params = {}) =>
      request.post(`${base.common}/api/coupon/page`, params),
    couponSearch: (params = {}) =>
      request.post(`${base.common}/api/coupon/search`, params),
    couponCoverSet: (params = {}) =>
      request.post(Api.pointUrl.couponCoverSet(), params),
    couponCoverDelete: (params = {}) =>
      request.post(`${base.common}/api/coupon/coverDelete`, params),
    couponCoverList: (id = "") =>
      request.post(`${base.common}/api/coupon/coverList/` + id),
    couponVideoSet: (params = {}) =>
      request.post(Api.pointUrl.couponVideoSet(), params),
    couponVideoDelete: (params = {}) =>
      request.post(`${base.common}/api/coupon/videoDelete`, params),
    couponVideoList: (id = "") =>
      request.post(`${base.common}/api/coupon/videoList/` + id),

    userCouponList: (params = {}) =>
      request.post(`${base.common}/api/userCoupon/list`, params),
    userCouponDetail: (id = "") =>
      request.post(`${base.common}/api/userCoupon/detail/` + id),
    userCouponAdd: (params = {}) =>
      request.post(`${base.common}/api/userCoupon/add`, params),
    userCouponEdit: (params = {}) =>
      request.post(`${base.common}/api/userCoupon/edit`, params),
    userCouponDelete: (params = {}) =>
      request.post(`${base.common}/api/userCoupon/delete`, params),
    userCouponPage: (params = {}) =>
      request.post(`${base.common}/api/userCoupon/page`, params),
    userCouponTransfer: (params = {}) =>
      request.post(`${base.common}/api/userCoupon/transfer`, params),
    userCouponSystemAdd: (params = {}) =>
      request.post(`${base.common}/api/userCoupon/systemAdd`, params),

    pointRecordList: (params = {}) =>
      request.post(`${base.common}/api/pointRecord/list`, params),
    pointRecordDetail: (id = "") =>
      request.post(`${base.common}/api/pointRecord/detail/` + id),
    pointRecordAdd: (params = {}) =>
      request.post(`${base.common}/api/pointRecord/add`, params),
    pointRecordEdit: (params = {}) =>
      request.post(`${base.common}/api/pointRecord/edit`, params),
    pointRecordDelete: (params = {}) =>
      request.post(`${base.common}/api/pointRecord/delete`, params),
    pointRecordPage: (params = {}) =>
      request.post(`${base.common}/api/pointRecord/page`, params),
    pointRecordChangePoint: (params = {}) =>
      request.post(`${base.common}/api/pointRecord/changePoint`, params),

    couponCodeDetail: (id = "") =>
      request.post(`${base.common}/api/couponCode/detail/` + id),
    couponCodeAdd: (params = {}) =>
      request.post(`${base.common}/api/couponCode/add`, params),
    couponCodeEdit: (params = {}) =>
      request.post(`${base.common}/api/couponCode/edit`, params),
    couponCodeDelete: (params = {}) =>
      request.post(`${base.common}/api/couponCode/delete`, params),
    couponCodePage: (params = {}) =>
      request.post(`${base.common}/api/couponCode/page`, params),
  };

  public static gacha = {
    gachaPoolPage: (params = {}) =>
      request.post(`${base.common}/api/gachaPool/page`, params),
    gachaPoolDetail: (id = "") =>
      request.post(`${base.common}/api/gachaPool/detail/` + id),
    gachaPoolAdd: (params = {}) =>
      request.post(`${base.common}/api/gachaPool/add`, params),
    gachaPoolEdit: (params = {}) =>
      request.post(`${base.common}/api/gachaPool/edit`, params),
    gachaPoolDelete: (params = {}) =>
      request.post(`${base.common}/api/gachaPool/delete`, params),

    gachaPrizePage: (params = {}) =>
      request.post(`${base.common}/api/gachaPrize/page`, params),
    gachaPrizeDetail: (id = "") =>
      request.post(`${base.common}/api/gachaPrize/detail/` + id),
    gachaPrizeAdd: (params = {}) =>
      request.post(`${base.common}/api/gachaPrize/add`, params),
    gachaPrizeEdit: (params = {}) =>
      request.post(`${base.common}/api/gachaPrize/edit`, params),
    gachaPrizeDelete: (params = {}) =>
      request.post(`${base.common}/api/gachaPrize/delete`, params),

    gachaPoolPrizePage: (params = {}) =>
      request.post(`${base.common}/api/gachaPoolPrize/page`, params),
    gachaPoolPrizeDetail: (id = "") =>
      request.post(`${base.common}/api/gachaPoolPrize/detail/` + id),
    gachaPoolPrizeAdd: (params = {}) =>
      request.post(`${base.common}/api/gachaPoolPrize/add`, params),
    gachaPoolPrizeEdit: (params = {}) =>
      request.post(`${base.common}/api/gachaPoolPrize/edit`, params),
    gachaPoolPrizeDelete: (params = {}) =>
      request.post(`${base.common}/api/gachaPoolPrize/delete`, params),

    gachaDrawPage: (params = {}) =>
      request.post(`${base.common}/api/gachaDraw/page`, params),
    gachaUserPrizePage: (params = {}) =>
      request.post(`${base.common}/api/gachaUserPrize/page`, params),

    config: (params = {}) => request.get(`${base.common}/api/gacha/config`, params),
    draw: (params = {}) => request.post(`${base.common}/api/gacha/draw`, params),
    draw10: (params = {}) =>
      request.post(`${base.common}/api/gacha/draw10`, params),
    drawHighBurst: (params = {}) =>
      request.post(`${base.common}/api/gacha/drawHighBurst`, params),
    drawHighBurst10: (params = {}) =>
      request.post(`${base.common}/api/gacha/drawHighBurst10`, params),
    drawPoolTicket: (params = {}) =>
      request.post(`${base.common}/api/gacha/drawPoolTicket`, params),
    drawPoolTicket10: (params = {}) =>
      request.post(`${base.common}/api/gacha/drawPoolTicket10`, params),
    myPending: (params = {}) =>
      request.get(`${base.common}/api/gacha/myPending`, params),
    myDrawPage: (params = {}) =>
      request.get(`${base.common}/api/gacha/myDrawPage`, params),
    use: (userPrizeId = "") =>
      request.post(`${base.common}/api/gacha/use/` + userPrizeId),
    useBatch: (params = {}) =>
      request.post(`${base.common}/api/gacha/useBatch`, params),
    systemUse: (userPrizeId = "") =>
      request.post(`${base.common}/api/gacha/systemUse/` + userPrizeId),
  };
  public static tempUrl = {
    title2sql: () => `${base.common}/api/temp/title2sql`,
  };
  public static temp = {
    title2sql: (params = {}) => request.post(Api.tempUrl.title2sql(), params),
  };
}

export default Api;
